<template>
<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.671 8.62073C13.671 11.1622 10.6272 12.312 9.86643 12.312M5.53979 10.8415C4.69747 10.0075 4.46729 9.14196 4.46729 7.86295V5.10184C4.46729 2.56032 6.5276 0.5 9.06913 0.5C10.9441 0.5 12.5571 1.62129 13.2743 3.22988" stroke="white" stroke-linecap="round"/>
<path d="M8.14893 5.10205H9.98966" stroke="white" stroke-linecap="round"/>
<path d="M7.22705 7.86279H8.29153" stroke="white" stroke-linecap="round"/>
<path d="M16.4315 6.94238V7.86275C16.4315 11.9292 13.135 15.2257 9.06852 15.2257C8.52237 15.2257 7.9901 15.1662 7.47785 15.0534M1.70557 6.94238V7.86275C1.70557 9.69336 2.37362 11.3679 3.47922 12.656" stroke="white" stroke-linecap="round"/>
<path d="M9.06885 15.2261V17.9872" stroke="white" stroke-linecap="round"/>
<line x1="0.5" y1="17.7929" x2="17.1031" y2="1.18982" stroke="white" stroke-linecap="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconMicrophoneSlash'
}
</script>
